<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication" style="margin-top: 5em">
<p class="dedication">
				For Andrea.
			</p>
<p class="dedication">
				It could be for no one else.
			</p>
</div>
<div class="footnote" id="prelim_footnotes">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?e558607c